/** Small inline icon set (stroke icons, 20px grid, currentColor). */
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement> & { size?: number };
const base = (size = 18): SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
});

export const IconDownload = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M10 3v9.5M6 8.8l4 3.9 4-3.9M4 15.5h12" />
  </svg>
);
export const IconLink = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M8.5 11.5a3 3 0 0 0 4.3 0l2.6-2.6a3 3 0 0 0-4.3-4.3l-.9.9M11.5 8.5a3 3 0 0 0-4.3 0L4.6 11.1a3 3 0 0 0 4.3 4.3l.9-.9" />
  </svg>
);
export const IconStar = ({ size, filled, ...p }: P & { filled?: boolean }) => (
  <svg {...base(size)} {...p} fill={filled ? 'currentColor' : 'none'}>
    <path d="m10 2.8 2.2 4.6 5 .6-3.7 3.4 1 5-4.5-2.5-4.5 2.5 1-5L2.8 8l5-.6z" />
  </svg>
);
export const IconChart = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M3 16.5h14M5.5 13V9M9 13V5.5M12.5 13v-3M16 13V7" />
  </svg>
);
export const IconPlus = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M10 4.5v11M4.5 10h11" />
  </svg>
);
export const IconMinus = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M4.5 10h11" />
  </svg>
);
export const IconFit = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M3.5 7.5v-4h4M12.5 3.5h4v4M16.5 12.5v4h-4M7.5 16.5h-4v-4" />
  </svg>
);
export const IconClose = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="m5 5 10 10M15 5 5 15" />
  </svg>
);
export const IconSearch = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <circle cx="8.8" cy="8.8" r="5.3" />
    <path d="m12.8 12.8 4 4" />
  </svg>
);
export const IconFilter = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M3.5 4.5h13l-5 6v4.5l-3 1.5v-6z" />
  </svg>
);
export const IconRefresh = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M16 10a6 6 0 1 1-1.8-4.3M16 3.5v3.7h-3.7" />
  </svg>
);
export const IconChevron = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="m7.5 4.5 5.5 5.5-5.5 5.5" />
  </svg>
);
export const IconInfo = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <circle cx="10" cy="10" r="7" />
    <path d="M10 9v4.5M10 6.4v.1" />
  </svg>
);
export const IconMap = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <circle cx="7" cy="8" r="3.5" />
    <circle cx="14" cy="13" r="2.5" />
    <circle cx="13.5" cy="5" r="1.3" />
  </svg>
);
export const IconUsers = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <circle cx="7.5" cy="7" r="2.8" />
    <path d="M2.8 16c.6-2.6 2.4-4 4.7-4s4.1 1.4 4.7 4M13 4.6a2.6 2.6 0 0 1 0 5M14.4 12.2c1.5.5 2.5 1.7 2.8 3.8" />
  </svg>
);
export const IconList = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M7 5.5h9.5M7 10h9.5M7 14.5h9.5M3.5 5.5h.1M3.5 10h.1M3.5 14.5h.1" />
  </svg>
);
export const IconBolt = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M11 2.5 4.5 11.2h5L9 17.5l6.5-8.7h-5z" />
  </svg>
);
export const IconExternal = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M11.5 3.5h5v5M16.5 3.5 9 11M14.5 11.5v4.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h4.5" />
  </svg>
);
export const IconCopy = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <rect x="6.5" y="6.5" width="10" height="10" rx="2" />
    <path d="M13.5 6.5v-2a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2" />
  </svg>
);
